// extracted by mini-css-extract-plugin
var _1 = "T6Vmz";
var _2 = "L9it7";
var _3 = "DBgqk";
var _4 = "TQUBp";
var _5 = "nhuvn";
export { _1 as "banner", _2 as "base", _3 as "error", _4 as "overlay", _5 as "warning" }
